import {withGetScreen} from "react-getscreen"
import c from './constants'

export default function withGetScreenExt(obj) {
    return withGetScreen(obj, c.MOBILE_OPTIONS)
}
